<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M12 17V3.66667C12 3.22464 11.8209 2.80072 11.5021 2.48816C11.1833 2.17559 10.7509 2 10.3 2H7.7C7.24913 2 6.81673 2.17559 6.49792 2.48816C6.17911 2.80072 6 3.22464 6 3.66667V17M2.7 6H15.3C16.2389 6 17 6.74619 17 7.66667V15.3333C17 16.2538 16.2389 17 15.3 17H2.7C1.76112 17 1 16.2538 1 15.3333V7.66667C1 6.74619 1.76112 6 2.7 6Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke-width="props.strokeWidth"
    />
  </svg>
</template>

<script setup>
  const props = defineProps({
    strokeWidth: {
      type: Number,
      default: 2,
    },
  });
</script>
